import createField from './createField';
import plain from './structure/plain';
export default createField(plain);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/Field.js
// module id = UpfO
// module chunks = 1